export default "https://cdn-static-staging.gokick.com/assets/283628f6afcc58bd5c20cb35203f3b9e086ea5d6/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";